import { makeAutoObservable, observable } from 'mobx';

import type * as THREE from 'three';

/**
 * Store for tracking editor UI Object3D refs that should be excluded from post-processing.
 * Components register/unregister their refs on mount/unmount.
 */
class EditorObjectsStore {
  private objects = observable.set<THREE.Object3D>();

  constructor() {
    makeAutoObservable(this);
  }

  register(obj: THREE.Object3D) {
    this.objects.add(obj);
  }

  unregister(obj: THREE.Object3D) {
    this.objects.delete(obj);
  }

  getAll(): THREE.Object3D[] {
    return [...this.objects];
  }

  forEach(callback: (obj: THREE.Object3D) => void): void {
    this.objects.forEach(callback);
  }

  get size(): number {
    return this.objects.size;
  }
}

export const editorObjectsStore = new EditorObjectsStore();
